import { registerClass } from '../../SatCoreRegistry';

import reportIdentityManager from '../../managers/reports/ReportIdentityManager';
import reportOverrideManager from '../../managers/reports/ReportOverrideManager';

export default class ReportOverrideService {
  static shouldUseCmapId = ({ forceUseCmapIdIfAllowed = false } = {}) => {
    const { isCmapStandardsReport } = reportIdentityManager;
    const { allowUseCmapId } = reportOverrideManager;

    return allowUseCmapId && (forceUseCmapIdIfAllowed || isCmapStandardsReport);
  };
}

registerClass('ReportOverrideService', ReportOverrideService);
